<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="CHAPTER1" id="uvKrKLxXwjeGJXh7jFql6q6"><a id="upMYBwFkR5aNoFJEL8vbrHA"></a>PART I</p>
<p class="CHAPTER-SUB">FLEDGLING KILL</p>
<p class="quote">“I always had a desire to inflict pain on others and to have others inflict pain on me. I always seemed to enjoy everything that hurt.”</p>
<p class="quote _idGenParaOverride-1"><span class="bold _idGenCharOverride-1">— Albert Fish</span><span class="CharOverride-4">, </span><span class="italics _idGenCharOverride-1">The Gray Man</span></p>
<p class="quote _idGenParaOverride-1"><span class="italics _idGenCharOverride-1"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// PartOne.vue?421c5040